import { GTTripV2SaleStatus } from 'gql/types.generated'
import { defineMessages } from 'react-intl'

export const saleStatusMessages = defineMessages({
  [GTTripV2SaleStatus.Activated]: {
    id: 'trips.sellStatus.activated',
    defaultMessage: 'Active'
  },
  [GTTripV2SaleStatus.Deactivated]: {
    id: 'trips.sellStatus.deactivated',
    defaultMessage: 'Inactive'
  }
})
